import {
    GridCellParams,
    GridColDef,
    GridValueFormatterParams,
    GridValueGetterParams,
} from '@mui/x-data-grid-pro';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Controls from '../common/controls/Controls';
import { formatDate, formatDateTime } from '../utils/dateUtils';
import { getCompositeProperty } from '../utils/objectUtils';
import CheckIcon from '@mui/icons-material/Check';

// export function renderReadonlyCheckboxCell(params: GridCellParams) {
//     if (params?.value)
//         return <div><CheckIcon/></div>;
//     return (
//         <></>
//     );
// }

export function renderReadonlyCheckboxCell(params: GridCellParams) {
    if (params?.value) {
        return (
            <div test-id={`readonly-checkbox-${params.field}-${params.row.id}`}>
                <CheckIcon />
            </div>
        );
    }
    return (
        <div test-id={`readonly-checkbox-${params.field}-${params.row.id}`}>
            {/* Tom div med test-id */}
        </div>
    );
}
export function getDateFormattedColumn(p: GridValueFormatterParams) {
    return p.value && formatDate(new Date(p.value as any));
}

export function renderCommaSeparatedStr(params: GridCellParams) {
    if (params?.value)
        return params?.value?.replaceAll(',', ', ');
    return (
        <></>
    );
}


export function renderPubliseringStatus(params: GridCellParams) {
    // if (!params.value)
    //     return '';
    switch (params.value as number) {
        case 0:
            return 'Publiseres ikke';
        case -1:
            return 'Ikke vurdert';
        case 1:
            return 'Publisér';
        default:
            return '';
    }
}

export function renderCompositeCheckboxCell(
    params: GridCellParams,
    propertyPath: string
) {
    return (
        <Controls.Checkbox
            disabled={true}
            readOnly={true}
            value={getCompositeProperty(params, propertyPath) ?? false}
            onChange={() => false}
        />
    );
}

// export function getDateFormattedColumn(p: GridValueFormatterParams) {
//     return p.value && formatDate(new Date(p.value as any));
// }

export function getDateTimeFormattedColumn({ row, field }: GridValueGetterParams) {
    return row[field] && formatDateTime(new Date(row[field]));
}

export function useTranslationColumns(columns: GridColDef[]) {
    const { t } = useTranslation();
    return columns?.map(i => {
        return {
            ...i,
            headerName: i.headerName ? t(i.headerName) : i.headerName,
        };
    });
}
